import ErrorIcon from '@mui/icons-material/Error'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

export const PaymentFailedDialog = ({ open, handleClose, handleOpenPaymentsDialog }) => {
    const { t } = useTranslation()
    
    const handleClickResendPayments = () => {
        handleOpenPaymentsDialog()
        handleClose()
    }

    return (
        <Dialog
            PaperProps={{
                style: {
                    width: '480px',
                },
            }}
            sx={{ overflow: 'hidden' }}
            open={open}
            onClose={handleClose}>
            <DialogTitle sx={{ margin: 0 }}>
                <ErrorIcon
                    color={'error'}
                    sx={{
                        fontSize: '36px',
                        display: 'inline-block',
                        verticalAlign: 'bottom',
                        margin: '0 12px',
                    }}
                />
                {t('finances.replenishmentError')}
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    <Grid size={12} sx={{ margin: '24px 0' }}>
                        <Typography variant="body1" my={2}>
                            {t('finances.operationDeclined')}
                        </Typography>
                    </Grid>
                </DialogContentText>
                <DialogActions sx={{ padding: 0 }}>
                    <Button color="secondary" fullWidth variant="contained" onClick={handleClose}>
                        {t('common.close')}
                    </Button>
                    <Button onClick={handleClickResendPayments} fullWidth variant="contained">
                        {t('finances.retry')}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}
